export const formatScoreChange = (n: number): string => {
  if (n > 0) return `+${n}`;
  if (n < 0) return `${n}`;

  return '0';
};
